import React from "react";
import { useStateValue } from "@/providers/state-provider";
import { addToCart, deleteFood } from "@/shared/lib/utils/functions";
import { FoodItem } from "@/root/types";
import { useIp } from "@/context/user-context";

interface ActionProps {
  food: FoodItem;
  children?: React.ReactNode;
}

const Action = ({ food, children }: ActionProps) => {
  const { state, dispatch } = useStateValue();
  const ip = useIp();
  
  return (
    <div 
    className="cursor-pointer"
    onClick={() => addToCart(state.cartItems, state.foodItems, food.id, dispatch, ip)}
    >
      {children} 
    </div>
  );
};

export default Action;